import { useIsSuperuser, useUserRole } from "hooks/users"
import { useIsLayoutAccountShareEnabled } from "resources/account"

// Whether the user may pick a starting layout / save-as-new: a superuser, or an account admin once layout_account_share is on for that account. (APP-2690)
export function useCanManageLayouts(): boolean {
  const isSuperuser = useIsSuperuser()
  const role = useUserRole()
  const isLayoutAccountShareEnabled = useIsLayoutAccountShareEnabled()
  return isSuperuser || (role === "admin" && isLayoutAccountShareEnabled)
}
